module.exports = __webpack_public_path__ + "static/11_PLATOS-ALE-SCHWEINSHAXE-D.d1c67a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/11_PLATOS-ALE-SCHWEINSHAXE-D.png
// module id = 654
// module chunks = 35783957827783